module.exports = __webpack_public_path__ + "statics/img/6f9fdcd.6f9fdcd0.png";